import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';
import { environment } from 'src/environments/environment';
import { ClasePerdida } from './models/clase-perdida';


@Injectable({ providedIn: 'root' })
export class ClasePerdidaService {

    private API_URL = `${environment.apiUrl}/api/UnidadClasesPerdidas`;

    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar
    ) { }

    getClasesPerdidas(idUnidad: number): Observable<ClasePerdida[]> {
        return this.http.get<{ results: ClasePerdida[], total: number }>(`${this.API_URL}/${idUnidad}`)
            .pipe(
                map((res: { results: ClasePerdida[], total: number }) => res.results),
                catchError(err => this.handleError(err, of([]))),
                shareReplay(1)
            );
    }

    getUnidadMaterias(idUnidad: number): Observable<MateriaMin[]> {
        return this.http.get<{ results: MateriaMin[], total: number }>(`${this.API_URL}/${idUnidad}/materias`)
            .pipe(
                map((res: { results: MateriaMin[], total: number }) => res.results),
                catchError(err => this.handleError(err, of([]))),
                shareReplay(1)
            );
    }

    createClasePerdida(clasePerdida: ClasePerdida) {
        return this.http.post<ClasePerdida>(`${this.API_URL}`, clasePerdida)
            .pipe(
                catchError(err => this.handleError(err, EMPTY)),
            );
    }

    updateClasePerdida(clasePerdida: ClasePerdida) {
        return this.http.put<ClasePerdida>(`${this.API_URL}`, clasePerdida)
            .pipe(
                catchError(err => this.handleError(err, EMPTY)),
            );
    }

    private handleError(err: any, res: Observable<any>) {
        let errorMessage: string;
        // = `Error ${err?.status}: ${err?.statusText}. Reintente la operación.`;
        if (err?.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err?.error?.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err?.status}: ${err?.body?.error}`;
        }
        this.snackBar.open(
            errorMessage,
            "Cerrar",
            {
                verticalPosition: "top",
                panelClass: ["error", "error-container"],
            }
        );
        console.error(err);
        // return res;
        return throwError(errorMessage);
    }

}